import { css } from '@emotion/css';

import { svgSizeStyles } from '@/utils/styles';

export const dialogSizeStyles = css`
  width: 44rem;
  max-height: 36rem;
  min-height: 22.4rem;
`;

export const headerContainer = css`
  .back-button {
    ${svgSizeStyles()}
  }
`;
